import React from 'react';
import PropTypes from 'prop-types';

import PDPFullWidthImageAndTextOption from './PDPFullWidthImageAndTextOption';

const PDPFullWidthImageAndTextSelector = ({
  value = {},
  title = '',
  onClickAction,
  onHoverAction,
  selectedId,
}) => (
  <div className="w-full flex flex-col">
    {title ? (
      <div className="PDPFullWidthImageAndTextSelector__title">{title}</div>
    ) : null}
    <PDPFullWidthImageAndTextOption
      content={value.content}
      onClickAction={onClickAction}
      onHoverAction={onHoverAction}
      valueId={value.id}
      sku={value.sku}
      optionValueName={value.value.trim()}
      selectedId={selectedId}
    />
  </div>
);

PDPFullWidthImageAndTextSelector.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.shape({
      image: PropTypes.string,
      textTitle: PropTypes.string,
      text: PropTypes.string,
      price: PropTypes.string,
    }),
  }),
  onClickAction: PropTypes.func,
  onHoverAction: PropTypes.func,
  title: PropTypes.string,
  selectedId: PropTypes.number,
};

export default PDPFullWidthImageAndTextSelector;
